module.exports = __webpack_public_path__ + "media/images/coming-soon-a7db1c6618d4cf5d1d5eb1246cab04f6.jpg";